const CheckBoxType={
    CHECKBOX_ACTIVE:'CHECKBOX_ACTIVE'
  };
  
  export default CheckBoxType;